import { gql } from "@apollo/client";

export const CREATE_USER_BOOK_BOOKMARK = gql`
  mutation CreateUserBookBookmark($input: CreateUserBookBookmarkInput!) {
    createUserBookBookmark(input: $input) {
      id
      character
      note
      chapterName
      progressPercent
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_USER_BOOK_BOOKMARK = gql`
  mutation DeleteUserBookBookmark($id: ID!) {
    deleteUserBookBookmark(id: $id) {
      id
      character
      note
      chapterName
      progressPercent
    }
  }
`;

export const VIEWER_BOOKMARKS = gql`
  query ViewerBookmarks($contentId: ID!) {
    viewerBookmarks(contentId: $contentId) {
      id
      character
      note
      chapterName
      progressPercent
      createdAt
      updatedAt
    }
  }
`;
